import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessAdminModule } from './access-admin/access-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AccessAdminModule
  ]
})
export class AccessModule { }
